var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"theChart",attrs:{"className":"echarts1"}},[_vm._v(_vm._s(_vm.data))])])
}
var staticRenderFns = []

export { render, staticRenderFns }